import { Component, Input, OnInit } from '@angular/core';
import {
  getBakeryDeadlineRules,
  IBakery,
  IBakeryScheduleDay,
  IFormattedBakerySchedule,
  ISchedule
} from '@cakeiteasy/web-utils';
import { NavigationService } from '@entire/services/navigation.service';

@Component({
  standalone: false,
  selector: 'hiw-bakery-row',
  templateUrl: './hiw-bakery-row.component.html',
  styleUrls: ['./hiw-bakery-row.component.scss']
})
export class HiwBakeryRowComponent implements OnInit {
  @Input() bakery: IBakery;

  public cities: string;

  public minForDisplay = 7;
  public delta = 4;
  public isExpand: boolean;
  public isOverflow: boolean;

  constructor(public navigate: NavigationService) {
  }

  public get deadlineRules(): IFormattedBakerySchedule[] | string {
    return this.bakery.customSchedule || getBakeryDeadlineRules(this.bakery.schedule as ISchedule<IBakeryScheduleDay>);
  }

  ngOnInit(): void {
    const citiesQnt = this.bakery.cities.length;
    this.isOverflow = citiesQnt > this.minForDisplay + this.delta;

    const slicedCities = this.isOverflow ?
      this.bakery.cities.slice(0, this.minForDisplay) :
      this.bakery.cities.slice(0, this.minForDisplay + this.delta);

    this.cities = slicedCities.join(', ');
  }

  public toggleExpand() {
    this.isExpand = !this.isExpand;
    const slicedCities = this.isExpand ? this.bakery.cities : this.bakery.cities.slice(0, this.minForDisplay);

    this.cities = slicedCities.join(', ');
  }
}
